// The one `Query.me` operation (specs/portal-authnz/SPEC.md §5) — server
// truth for identity + resolved capabilities + impersonation state. Shared
// by two callers: src/stores/auth.ts#syncViewer (capability gating, no UI of
// its own) and DashboardPage.vue (renders the identity/membership/profile
// cards). One document, one cache entry, both callers read the same shape.
//
// `me` requires authentication and errors for public-token principals — it
// is only ever queried once the auth store reports `authenticated`.
import { graphql } from 'src/graphql'

export const MeDocument = graphql(/* GraphQL */ `
  query Me {
    me {
      principal {
        id
        displayName
        kind
      }
      person {
        id
        givenName
        familyName
        email
        membership {
          team {
            id
            name
            # university (ui-conventions.md #98): DashboardPage's "Team"
            # membership card renders this via src/core/teamDisplay.ts, not
            # the raw name — outside the team view itself.
            university {
              name
              nameShort
              nameInternal
              city
              country {
                iso2
              }
            }
          }
          role
        }
        profile {
          dateOfBirth
          mobile
          company
          education
          clothingSize
          department
          studies
          teamRoleTitle
          spokenLanguages
          drivingLicenses
          isFirefighter
          firstAid
          commWhatsapp
          commSignal
          fsgExperience
        }
      }
      realm
      ceilingRoles
      roles {
        name
        qualifier
        competition {
          id
          name
        }
        team {
          id
          name
          # ui-conventions #98: role chips render the team via teamDisplay.
          university {
            name
            nameShort
            nameInternal
            city
            country {
              iso2
            }
          }
        }
      }
      scopes {
        kind
        action
        all
        self
        tenants {
          id
        }
        competitions {
          id
        }
        teams {
          id
        }
      }
      impersonation {
        realSubject
        realPerson {
          id
          givenName
          familyName
        }
        target {
          id
          givenName
          familyName
        }
      }
    }
  }
`)
